import axios from "axios";
import querystring from "querystring";
import React, { useCallback, useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import ImagePage from "./ImagePage";
var { Modal } = require("react-bootstrap");
const SavedImagesSection = ({ pageType, loginPopup, sessionData, searchImageText }) => {
  const [rename, setRename] = useState(false);
  const [extraSection, setExtraSection] = useState();
  const [newRename, setNewRename] = useState(false);
  const [updateAlbum, setUpdateAlbum] = useState("");
  const [LoadingNew, setLoadingNew] = useState(false);
  const [albumData, setAlbumData] = useState([]);
  const [albumId, setAlbumId] = useState("");
  const [createAlbumModal, setCreateAlbumModal] = useState(false);
  const [LoadingNewAlbum, setLoadingNewAlbum] = useState(false);
  const [createAlbumText, setCreateAlbumText] = useState("");
  const [loading, setLoading] = useState(false);
  const [deleteAlbum, setDeleteAlbum] = useState(false);
  const [deletedId, setDeleteId] = useState("");
  const [gallery, setGallery] = useState(false);
  const [galleryImages, setGalleryImages] = useState([]);
  const [loadinGallery, setGalleryLoading] = useState(false);
  const [imagesData, setImagesData] = useState([]);
  const [albumName, setAlbumName] = useState("");
  const [newImageInput, setNewImageInput] = useState("");
  const inputRef = useRef(null);
  const [singleImageModal, setSingleImageModal] = useState(false);
  const handleRename = () => {
    setRename(!rename);
  };
  const handleNewReame = (index, name) => {
    setAlbumName(name);
    setAlbumId(index);
    if (window.innerWidth > 768) {
      setExtraSection(index);
    } else {
      setNewRename(!newRename);
    }
  };
  const renameAlbum = () => {
    setLoadingNew(true);
    let url = `https://api.bookeventz.com/ImageTags/updateTagAlbum`;
    let formData = {
      name: updateAlbum,
      user_profile_id: sessionData?.user_profile_id,
      is_active: 1,
      id: albumId,
    };
    axios.post(url, querystring.stringify(formData)).then((formUpdate) => {
      if (formUpdate.data?.success == true) {
        getAlbums();
        setLoadingNew(false);
        setRename(!rename);
        handleNewReame(false);
      }
    });
    (error) => {
      console.log(error);
    };
  };
  const getAlbums = () => {
    if ("userName" in sessionData) {
      setLoading(true);
      let url = `https://api.bookeventz.com/imageTags/getUsersAlbum?user_profile_id=${sessionData?.user_profile_id}&is_active=1`;
      try {
        axios.get(url).then((res) => {
          setAlbumData(res.data?.data);
          setImagesData(res.data?.userImageData);
          setLoading(false);
        });
      } catch (err) {
        console.log(err, "error");
      }
    } else {
      loginPopup(true);
    }
  };
  useEffect(() => {
    setTimeout(() => {
      getAlbums();
    }, 2000);
  }, [sessionData]);
  const createAlbum = () => {
    if ("userName" in sessionData) {
      setLoadingNewAlbum(true);
      let url = `https://api.bookeventz.com/ImageTags/createImageTagAlbum`;
      let formData = {
        name: createAlbumText,
        user_profile_id: sessionData?.user_profile_id,
        is_active: 1,
      };

      axios.post(url, querystring.stringify(formData)).then((formUpdate) => {
        if (formUpdate?.data?.success == true) {

          getAlbums();
          setLoadingNewAlbum(false);
          setCreateAlbumModal(false);
        }
      });
    } else {
      loginPopup(true);
    }

  };
  const handleDeleteAlbum = (id, name) => {
    let url = "https://api.bookeventz.com/ImageTags/updateTagAlbum";
    let formData = {
      name: albumName,
      user_profile_id: sessionData?.user_profile_id,
      is_active: 0,
      id: albumId,
    };
    axios.post(url, querystring.stringify(formData)).then((res) => {
      if (res.data.success == true) {
        setDeleteAlbum(!deleteAlbum);
        handleNewReame();
        getAlbums();
      }
    });
  };
  const handleDelete = (id) => {
    setDeleteId(id);
    setDeleteAlbum(!deleteAlbum);
  };
  var settings = {
    infinite: false,
    centerMode: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    showFull: false,
    showLoader: false,
    dots: false,
    arrows: true,
  };
  const getmodalImages = (aId) => {
    setGallery(!gallery);
    setGalleryLoading(true);
    let url = `https://api.bookeventz.com/imageTags/getUsersAlbumImages?album_id=${aId}&if_active=1`;
    setTimeout(() => {
      try {
        axios.get(url).then((res) => {
          setGalleryLoading(false);
          setGalleryImages(res.data?.data);
        });
      } catch (err) {
        console.log(err, "error");
      }
    }, 2000);

  };
  const download = async (url, name) => {
    let link = "https://media.bookeventz.com/html/bookeventz.com/images/restaurant-picture/" + url;
    const a = document.createElement("a");
    // const blob = new Blob([link], {type: "image/jpg"});
    // a.href = await URL.createObjectURL(blob);
    a.href = await toDataURL(link);
    a.download = name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    return;
  };
  const toDataURL = (url) => {
    return fetch(url)
      .then((response) => {
        return response.blob();
      })
      .then((blob) => {
        return URL.createObjectURL(blob);
      });
  };
  const leftClick = useCallback(() => {
    inputRef?.current.slickPrev();
  }, []);

  const rightClick = useCallback(() => {
    inputRef?.current.slickNext();
  }, []);

  const handleKeypress = useCallback(
    (e) => {
      if (e.keyCode === 37) {
        leftClick();
      } else if (e.keyCode === 39) {
        rightClick();
      } else if (e.keyCode === 27) {
        openImageCarousel(false);
      }
    },
    [leftClick, rightClick]
  );
  useEffect(() => {
    document.addEventListener("keydown", handleKeypress);
    return () => document.removeEventListener("keydown", handleKeypress);
  }, [handleKeypress]);
  const handleSingleImageModaL = (name) => {
    setNewImageInput(name);
    setSingleImageModal(true);
  };
  return (
    <>
      <div
        id="saved-image-wrapper"
        onClick={() => {
          if (albumId == extraSection) {
            setExtraSection("");
          }
        }}
      >
        <div id="saved-a-section">
          <div id="a-create">
            <div id="a-top" onClick={() => setCreateAlbumModal(!createAlbumModal)}>
              <img src="../../media/plus.svg" alt="Plus Iocn" />
            </div>
            <span id="t98">Create Album</span>
          </div>
          {loading == true ? (
            <div id="loading">
              <img src="../../media/Pino.svg" alt="Loading image" />
            </div>
          ) : (
            albumData !== undefined &&
            albumData?.map((a, i) => {

              return (
                <div id="a-create" key={i}>
                  <div id="b-top" onClick={() => getmodalImages(a.id)}>
                    <div id="b1">
                      <span id="b11">
                        {(a.images?.index == 0 && a.images[0] !== null) ||
                          a.images[0] !== undefined ? (
                          <img
                            src={`https://media.bookeventz.com/html/bookeventz.com/images/albums/${a.images[0]?.image_name}`}
                          />
                        ) : null}
                      </span>
                      <span id="b12">
                        {(a.images?.index == 1 && a.images[1] !== null) ||
                          a.images[1] !== undefined ? (
                          <img
                            src={`https://media.bookeventz.com/html/bookeventz.com/images/albums/${a.images[1]?.image_name}`}
                          />
                        ) : null}
                      </span>
                    </div>
                    <div id="b2">
                      <span id="b13">
                        {(a.images?.index == 2 && a.images[2] !== null) ||
                          a.images[2] !== undefined ? (
                          <img
                            src={`https://media.bookeventz.com/html/bookeventz.com/images/albums/${a.images[2]?.image_name}`}
                          />
                        ) : null}
                      </span>
                    </div>
                  </div>
                  <span id="t98">
                    {a?.name}
                    <img
                      src="../../media/editk.svg"
                      alt="Plus Iocn"
                      onClick={() => handleNewReame(a.id, a?.name)}
                    />
                  </span>

                  {a.id == extraSection && (
                    <div id="t-options">
                      <span id="t-opt" onClick={() => handleRename()}>
                        Rename Album
                      </span>
                      <span id="divider"></span>
                      <span id="t-opt">Share Album</span>
                      <span id="divider"></span>
                      <span id="t-opt" onClick={() => handleDelete(a.id)}>
                        Delete Album
                      </span>
                    </div>
                  )}
                </div>
              );
            })
          )}

          {imagesData.length > 0 &&
            imagesData !== undefined &&
            imagesData.map((im, index) => (
              <div id="t-create">
                <div id="t-tupper">
                  <img
                    src="../../media/dLoad.svg"
                    alt="Plus Iocn"
                    id="dLoad"
                    onClick={() => download(im.image_name, im.image_name)}
                  />
                  <img src="../../media/pHeart.svg" alt="Pink Heart Iocn" id="pHeart" />

                  <a
                    href={`https://api.whatsapp.com/send?text=https://www.bookeventz.com/real-events/image-page?imageText=${im?.image_name}`}
                    data-action="share/whatsapp/share"
                    target="_blank"
                  >
                    <img src="../../media/sh.svg" alt="Share Iocn" id="sH" />
                  </a>
                  <img
                    src={`https://media.bookeventz.com/html/bookeventz.com/images/albums/${im.image_name}`}
                    alt="Event Image"
                    id="t-img"
                    onClick={() => handleSingleImageModaL(im.image_name)}
                  />
                </div>
              </div>
            ))}
        </div>
      </div>
      <Modal dialogClassName={"rename-modal"} show={rename} onHide={handleRename} animation={false}>
        <div id="rename-wrapper">
          {LoadingNew == true ? (
            <>
              <div id="loading">
                <img src="../../media/Pino.svg" alt="Loading image" />
              </div>
            </>
          ) : (
            <>
              <input
                defaultValue={albumName !== "" && albumName}
                type="text"
                placeholder="Enter album name"
                onChange={(e) => setUpdateAlbum(e.target.value)}
              />
              <div id="r-buttons">
                <button id="r-g" onClick={() => handleRename()}>
                  Cancel
                </button>
                <button id="r-p" onClick={() => renameAlbum()}>
                  Rename
                </button>
              </div>
            </>
          )}
        </div>
      </Modal>
      <Modal
        dialogClassName={"mobile-rename-modal"}
        show={newRename}
        onHide={handleNewReame}
        animation={false}
      >
        <div id="mobile-rename-wrapper">
          <span id="close-icon-mm">
            <img
              src="../../media/cross.svg"
              alt="Cross Icon Mobile"
              onClick={() => handleNewReame()}
            />
          </span>
          <span id="mt-opt" onClick={() => handleRename()}>
            Rename Album
          </span>
          <a
            href={`https://api.whatsapp.com/send?text=https://www.bookeventz.com/real-events/saved-albums`}
            data-action="share/whatsapp/share"
            target="_blank"
          >
            <span id="mt-opt">Share Album</span>
          </a>
          <span id="mt-opt" onClick={() => handleDelete(albumId)}>
            Delete Album
          </span>
        </div>
      </Modal>
      <Modal
        dialogClassName={"rename-modal"}
        show={createAlbumModal}
        onHide={setCreateAlbumModal}
        animation={false}
      >
        <div id="rename-wrapper">
          {LoadingNewAlbum == true ? (
            <>
              <div id="loading">
                <img src="../../media/Pino.svg" alt="Loading image" />
              </div>
            </>
          ) : (
            <div
              id="zika"
              onKeyDown={(e) => {
                if (e.keyCode === 13) {
                  createAlbum();
                }
              }}
            >
              <input
                type="text"
                placeholder="Enter album name"
                onChange={(e) => setCreateAlbumText(e.target.value)}
              />
              <div id="r-buttons">
                <button id="r-g" onClick={() => setCreateAlbumModal(!createAlbumModal)}>
                  Cancel
                </button>
                <button onClick={() => createAlbum()} id="r-p">
                  Create
                </button>
              </div>
            </div>
          )}
        </div>
      </Modal>
      <Modal
        dialogClassName={"rename-modal"}
        show={deleteAlbum}
        onHide={handleDelete}
        animation={false}
      >
        <div id="rename-wrapper">
          <span id="dyrw">Do you really want to delete ?</span>
          <div id="r-buttons">
            <button id="r-g" onClick={() => handleDelete()}>
              Cancel
            </button>
            <button id="r-p" onClick={() => handleDeleteAlbum()}>
              Delete
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        dialogClassName={"gallery-modal"}
        show={gallery}
        onHide={getmodalImages}
        animation={false}
      >
        <div id="gallery-modal-wrapper">
          <span id="cancel-g" onClick={() => setGallery(false)}>
            <img
              src="../../media/ArrowCross.svg"
              alt="Cancel icon to close gallery"
              id="cancel-g-btn"
            />
          </span>

          <Slider {...settings} ref={inputRef}>
            {loadinGallery == true ? (
              <>
                <div id="loading">
                  <img src="../../media/Pino.svg" alt="Loading image" />
                </div>
              </>
            ) : galleryImages?.length == 0 ? (
              <div id="no-imgs">There are no images here yet !</div>
            ) : (
              galleryImages?.map((d, index) => {
                let aTypeUrl = "";
                let type = d.attach_type;

                if (type == 3) {
                  aTypeUrl =
                    "https://media.bookeventz.com/884x350/html/bookeventz.com/images/banquet-layout/" +
                    d.image_name;
                } else if (type == 1) {
                  aTypeUrl =
                    "https://media.bookeventz.com/html/bookeventz.com/images/albums/" +
                    d.image_name;
                } else if (type == 2) {
                  aTypeUrl =
                    "https://media.bookeventz.com/884x350/html/bookeventz.com/images/restaurant-award/" +
                    d.image_name;
                } else if (type == 12) {
                  aTypeUrl =
                    "https://media.bookeventz.com/884x350/html/bookeventz.com/images/albums/" +
                    d.image_name;
                }
                else if (type == 13) {
                  aTypeUrl =
                    "https://media.bookeventz.com/html/bookeventz.com/images/albums/" +
                    d.image_name;
                }
                return (
                  <>
                    <div id="image-wrapper-g">
                      <img key={index} src={aTypeUrl} id="main-i-g" />
                    </div>

                    <div id="bottom-wra-g">
                      {d?.description == null && <div id="title-7">{d?.description}</div>}

                      <div id="bottom-g">
                        <a href={`https://www.bookeventz.com/${d?.product_link}`} target="_blank">
                          <span id="v-name">
                            <img src="../../media/pSh.svg" alt="Download Image" />
                            {d?.product_name?.length > 13
                              ? d?.product_name?.slice(0, 13) + "..."
                              : d?.product_name}
                          </span>
                        </a>
                        <img
                          src="../../media/blackDown.svg"
                          alt="Download Image"
                          id="z-1"
                          onClick={() => {
                            download(d?.image_name, d?.image_name);
                            return;
                          }}
                        />

                        <a
                          href={`https://api.whatsapp.com/send?text=https://www.bookeventz.com/real-events/image-page?imageText=${d?.image_name}`}
                          data-action="share/whatsapp/share"
                          target="_blank"
                        >
                          <img src="../../media/blackShare.svg" alt="Share Image" id="z-0" />
                        </a>
                      </div>
                    </div>
                  </>
                );
              })
            )}
          </Slider>
        </div>
      </Modal>
      <Modal
        dialogClassName={"gallery-modal"}
        show={singleImageModal}
        onHide={setSingleImageModal}
        animation={false}
      >
        <ImagePage
          searchImageText={searchImageText}
          newImageInput={newImageInput}
          Modal={setSingleImageModal}
        />
      </Modal>
    </>
  );
};

export default SavedImagesSection;
